export default __webpack_public_path__ + "static/media/btn_off_1.c4254258.svg";